module.exports = __webpack_public_path__ + "static/brooklyn-7ce4e18dd2d517bdd40d4d02401cecb2.png";